module.exports = __webpack_public_path__ + "static/media/covid-19-site-template-shot-2.f308b071.png";